import React from 'react'

const CvvInputTelcelContainer = (props) => {
    const [validationColorLabel, setValidationColorLabel] = React.useState("");
    const [validationColorBorder, setValidationColorBorder] = React.useState("");
    const [validationColor, setValidationColor] = React.useState("");

    React.useEffect(() => {
        setValidationColorLabel(props.isValid ? "#0071d1" : "#222222");
        setValidationColorBorder(props.isValid ? "#0071d1" : "red");
        setValidationColor(props.isValid ? "#222222" : "red");
    },[props.isValid])

    const styles = {
        table: {
            width: "100%",
            marginTop: "16px",
            marginBottom: "15px",
            border: "0px",
            borderCollapse: "collapse"
        },
        tdLabel: {
            width: "35px",  
            verticalAlign: "middle",
            fontFamily: "AMX-Bold",
            fontSize: "14px",
            textAlign: "left"
        },
        tdHelp: {
            width: "24px",
            verticalAlign: "top",
            textAlign: "right"
        },
        input: {
            WebkitAppearance: "none",
            border: "none",
            fontFamily: "AMX-Regular",
            fontSize: "14px",
            color: "#222222",
            borderBottom: "1px solid #bac9d8",
            width: "100%",
            paddingBottom: "2px",
            position: "relative",
            top: "-2px"
        },
        imgHelp: {
            width: "16px",
            height: "16px"
        }
    }

    return (
        <table style={{ ...styles.table, display: props.visible ? "table" : "none" }} cellPadding="0" cellSpacing="0">
            <tbody>
                <tr>
                    <td style={ styles.tdLabel }>
                        <span style={{ color: `${validationColorLabel}` }}>CVV:</span>
                    </td>
                    <td>
                        <input 
                            id={`pagoDeServicios_${props.input.id}_${props.serviceName}`}
                            type="text"
                            inputMode='numeric'
                            name={props.input.field.input.name}
                            placeholder={props.input.field.input.placeholder}
                            value={props.value}  
                            onChange={(e) =>{props.handleInputChange(e, props.input.type)}}
                            readOnly={props.input.field.input.disabled?true:false}
                            style={{ ...styles.input, borderBottom: `1px solid ${validationColorBorder}`, color: `${validationColor}` }}
                            /> 
                    </td>
                    <td style={ styles.tdHelp }>
                        <img 
                            src={`${process.env.REACT_APP_IMAGES_CONTAINER_TELCEL}iconTelcelContainer.png `}
                            style={ styles.imgHelp } 
                            onClick={(e) => props.handleClickTooltip(e, "cvv")} />
                    </td>
                </tr>
            </tbody>
        </table>
    )
}

export default CvvInputTelcelContainer